import React from "react";

import Modals from "../popupModal/modal";

const SignoutModal = ({ isOpen, onSuccess, closeModal }) => {
  return (
    <Modals
      isOpen={isOpen}
      onRequestClose={() => closeModal}
      title="Sign out"
      btnDark={{
        label: "Sign out",
        onclick: () => {
          onSuccess();
          closeModal();
        },
      }}
      btnOutline={{
        label: "Cancel",
        onclick: () => {
          closeModal();
        },
      }}
    >
      <React.Fragment>
        <button
          onClick={closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <p className="mx-auto text-center denyAppointmentText">
          If you sign out of the app you won’t appear in the search results and
          the patients won’t be able to contact you.
          <br />
          <br />
          Are you sure you want to sign out of the app?
        </p>
      </React.Fragment>
    </Modals>
  );
};

export default SignoutModal;
